(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/login-closed.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/login-closed.js');
"use strict";

(function (svs, React) {
  'use strict';

  class LoginClosed extends React.Component {
    componentDidMount() {
      const loginClosedArticle = svs.grassroots_partner.data.cms.loginClosedArticle;
      const loginClosed = document.getElementById('loginClosed');
      loginClosed.innerHTML = loginClosedArticle;
    }
    render() {
      return React.createElement("div", {
        className: "col-xs-12 bg-white"
      }, React.createElement("div", {
        className: "col-md-6 col-md-offset-3 panel padding-xs-1 f-content"
      }, React.createElement("h2", {
        className: "align-center"
      }, "Inloggningen st\xE4ngd"), React.createElement("p", {
        id: "loginClosed"
      }), React.createElement("a", {
        className: "btn btn-300 btn-inverted w100 btn-link",
        href: "/grasrotenpartner"
      }, React.createElement("span", {
        className: "btn-link-text"
      }, "Ok, jag f\xF6rst\xE5r"))));
    }
  }
  svs.grassroots_partner.LoginClosed = LoginClosed;
})(svs, React);

 })(window);